import cn from 'classnames';
import { StyledAdminDropdownOption } from './styles';

interface IAdminDropdownOptionProps extends React.HTMLAttributes<HTMLDivElement> {
  children?: React.ReactNode;
  current?: boolean;
}

export const AdminDropdownOption = ({ children, current, onClick }: IAdminDropdownOptionProps) => {
  return (
    <StyledAdminDropdownOption onClick={onClick} className={cn(current && 'current')}>
      {children}
    </StyledAdminDropdownOption>
  );
};
